import React, {useEffect, useRef, useState} from 'react';
import {Box, Link, Spinner, Text, useDimensions} from '@chakra-ui/react';
import HomeHero from './Home/Components/hero';
import Navbar from './Home/Common/navbar';
import {Navigate, useSearchParams} from 'react-router-dom';
import axios from "axios";
import {SEO} from "../components/SEO";
import {HomeContent} from "./Home/Components/HomeContent";
import Container from "../components/Container";
import {useRecoilState} from "recoil";
import {homeState} from "../states";

const HomePage = () => {
    const [searchParams] = useSearchParams();
    const param = 'Crossover / Public Healthcare'; // searchParams.get('ca');
    const [homeData, setHomeData] = useState(undefined)
    const [data] = useRecoilState(homeState)
    const [activeTab, setActiveTab] = useState('Crossover / Public Healthcare')
    const [tiles, setTiles] = useState(undefined)

    const scrollToTop = () => {
        const homeContent = document.getElementById("home-content");
        window.scrollTo({
            top: homeContent.offsetTop,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const fetchHomeData = async () => {
            const response = await axios.get(`/wp-json/wp/v2/pages?acf_format=standard&slug=home`).then(resp => {
                return resp.data[0];
            });
            setHomeData(response)
        }
        fetchHomeData()
    }, [])

    const options = [
{
            title: 'Crossover / Public Healthcare',
            key: 'Public Healthcare',
            href: ``,
        },
    ];

    useEffect(() => {
        setActiveTab(options.find((fid) => fid.title === param)?.key)
    }, [options, param])

    useEffect(() => {
        if (activeTab && data) {
            setTiles(data[activeTab.toLowerCase().replace(" ", "_")])
        }
    }, [data, activeTab])

    return (
        <>
            <SEO
                image={homeData?.yoast_head_json?.og_image?.length > 0 ? homeData?.yoast_head_json?.og_image[0]?.url : null}
                title={homeData?.title?.rendered}
                ogTitle={homeData?.yoast_head_json?.og_title}
                description={homeData?.yoast_head_json?.og_description || homeData?.excerpt?.rendered}
                url={homeData?.yoast_head_json?.og_url}
                type={homeData?.yoast_head_json?.og_type}
                siteName={homeData?.yoast_head_json?.og_site_name}
                robots={`${homeData?.yoast_head_json?.robots.index}, ${homeData?.yoast_head_json?.robots.follow}`}
            />
            <Box px={['5', '10']}>
                <HomeHero/>
                {!tiles ? (<Box my={20}>
                    <Spinner color='blue.600' size='xl'/>
                </Box>) : (
                    <Box id="home-content">
                        <HomeContent title={activeTab} tiles={tiles}/>
                    </Box>
                )}

                <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                    <Box position={'relative'}>
                        <Container>
                            <Box pt={'100px'} pb={'120px'}>
                                <Text fontSize="18px" lineHeight={'25.2px'}>
                                    See legend on <Link href="/contact">Contact</Link> page
                                </Text>
                            </Box>
                        </Container>
                    </Box>
                </Box>
                {/*!param && <Navigate to={`/?ca=${encodeURI('Crossover / Public Healthcare')}`}/> */} 
            </Box>
        </>

    );
};
export default HomePage;
